import styles from "./MapDayTag.module.css";

const SHORT_DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] as const;
const SHORT_MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
] as const;

interface MapDayTagProps {
  /** Day strip's selected day. `null` → "Now" (markers show live hour). */
  selectedDay: number | null;
  /** "YYYY-MM-DD" for the selected day (only consulted when `selectedDay`
   *  is ≥ 2). Sourced from the forecast's `ScoredDay.date`. */
  date: string | undefined;
}

/**
 * Floating label centered at the top of the spots map. Echoes the day
 * strip's current selection so users who interact with the map (rather
 * than the strip below) have a clear reference for what wind data the
 * markers are showing.
 */
export function MapDayTag({ selectedDay, date }: MapDayTagProps) {
  const label = (() => {
    if (selectedDay === null || selectedDay === 0) return "Now";
    if (selectedDay === 1) return "Tomorrow";
    if (!date) return "";
    const d = new Date(`${date}T12:00:00`);
    return `${SHORT_DAYS[d.getDay()]} ${d.getDate()} ${SHORT_MONTHS[d.getMonth()]}`;
  })();
  if (!label) return null;
  return <div className={styles.mapDayTag}>{label}</div>;
}
